import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
//import { BottomLeft } from './video-banner-svgs/BottomLeft';
import { BottomLeftCorner } from './video-banner-svgs/BottomLeftCorner';
import { BottomMiddle } from './video-banner-svgs/BottomMiddle';
//import { BottomRight } from './video-banner-svgs/BottomRight';
import { BottomRightCorner } from './video-banner-svgs/BottomRightCorner';
import { LeftMiddle } from './video-banner-svgs/LeftMiddle';
import { RightMiddle } from './video-banner-svgs/RightMiddle';
import { TopLeft } from './video-banner-svgs/TopLeft';
import { TopLeftCorner } from './video-banner-svgs/TopLeftCorner';
import { TopMiddle } from './video-banner-svgs/TopMiddle';
import { TopRight } from './video-banner-svgs/TopRight';
import { TopRightCorner } from './video-banner-svgs/TopRightCorner';

const MIDDLE_HEIGHT = 'calc((9 / 16 * (100vw - 514px)) - 380px)';

export function VideoBannerFrame() {
  // const [middleHeight, setMiddleHeight] = useState<number>(0);
  // const middleRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   if (!!middleRef && !!middleRef.current) {
  //     setMiddleHeight(middleRef.current.clientHeight);
  //   }
  // }, [middleRef]);

  // useEffect(() => {
  //   const handleResize = () => {
  //     if (!!middleRef && !!middleRef.current) {
  //       setMiddleHeight(middleRef.current.clientHeight);
  //     }
  //   };
  //   window.addEventListener('resize', handleResize);
  //   handleResize();
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  return (
    <Grid
      container
      sx={{
        position: 'absolute',
        height: '100%',
        width: '100%',
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          height: '200px',
        }}
      >
        <Grid item>
          <TopLeftCorner height={200} width={180} />
        </Grid>
        <Grid item sx={{ overflow: 'hidden' }}>
          <TopLeft height={30} width={3000} />
        </Grid>
        <Grid item>
          <TopMiddle height={50} width={300} />
        </Grid>
        <Grid item sx={{ overflow: 'hidden' }}>
          <TopRight height={30} width={3000} />
        </Grid>
        <Grid item>
          <TopRightCorner height={200} width={180} />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          height: 'calc(100% - 400px)',
        }}
      >
        <Grid item>
          <LeftMiddle height={MIDDLE_HEIGHT} width={30} />
        </Grid>
        <Grid item>
          <RightMiddle height={MIDDLE_HEIGHT} width={30.5} />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          height: '200px',
        }}
      >
        <Grid item>
          <BottomLeftCorner height={200} width={300} />
        </Grid>
        {/* <Grid
          item
          sx={{
            height: '100%',
            width: '50%',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              height: '50%',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              overflow: 'hidden',
              mb: '44.5px',
              bottom: 0,
            }}
          >
            <BottomLeft height={30} width={1000} />
          </Box>
        </Grid> */}
        <Grid
          item
          sx={{
            height: '100%',
            width: '200%',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              height: '50%',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              mb: '44.5px',
              bottom: 0,
            }}
          >
            <BottomMiddle height={8} width={3000} />
          </Box>
        </Grid>
        {/* <Grid
          item
          sx={{
            overflow: 'hidden',
            height: '100%',
            width: '50%',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              height: '50%',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              mb: '44.5px',
              bottom: 0,
            }}
          >
            <BottomRight height={30} width={1000} />
          </Box>
        </Grid> */}
        <Grid item>
          <BottomRightCorner height={200} width={300} />
        </Grid>
      </Grid>
    </Grid>
  );
}
